import { CSSProperties } from 'react';

export const header: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0px 24px',
  height: '64px',
  backgroundColor: '#FFF',
  boxShadow: '0px 3px 3px rgba(0, 0, 0, 0.3)',
  zIndex: 10,
};
